
import { onMounted } from '@nuxtjs/composition-api';
import useErrorHandler from '~/composable/useErrorHandler';
export default {
  setup() {
    const { redirectToErrorPage } = useErrorHandler()
    onMounted(() => {
      redirectToErrorPage(404)
    })
    return {}
  }
}
